<script setup>
defineProps({
  count: {
    required: true,
    type: Number,
  },
  icon: {
    required: true,
    type: String,
  },
});

const iconMap = {
  'in-sync': {
    icon: 'cloud-tick',
    class: 'tw-text-success-600'
  },
  'not-in-sync': {
    icon: 'cloud-error',
    class: 'tw-text-caution-600'
  },
  'not-found': {
    icon: 'folder-error',
    class: 'tw-text-danger'
  },
  'updating': {
    icon: 'updating-clock',
    class: 'tw-text-info'
  },
}
</script>

<template>
  <div class="tw-flex tw-items-center tw-gap-4">
    <div class="tw-flex tw-gap-2 tw-items-center">
      <svg-vue
        class="tw-w-6 tw-h-6 tw-shrink-0"
        :icon="`icons/${iconMap[icon].icon}`"
        :class="[iconMap[icon].class]"
      />

      <span class="tw-font-bold tw-text-2xl tw-text-neutral-900">
        <slot />
      </span>
    </div>

    <span class="tw-bg-primary-300 tw-rounded-full tw-text-white tw-font-bold tw-font-xs tw-h-6 tw-w-6 tw-flex tw-items-center tw-justify-center">
      {{ count }}
    </span>
  </div>
</template>
